module.exports = __webpack_public_path__ + "img/8bf8aa5.png";